import { render } from "./SendItemGold.vue?vue&type=template&id=070e6340&scoped=true"
import script from "./SendItemGold.vue?vue&type=script&lang=js"
export * from "./SendItemGold.vue?vue&type=script&lang=js"

import "./SendItemGold.vue?vue&type=style&index=0&id=070e6340&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070e6340"]])

export default __exports__